// extracted by mini-css-extract-plugin
export default {"wrapper":"hwg80w","logo":"blPW0z","hidden":"xUC66m"};